// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1KgsG","form":"styles_form__cfRXW"};